import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  quick_quotes_Bike,
  QuickQuote_Post,
  Err_quotes,
} from "../../Redux/actions/NumBikeation";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { Previousinsurer } from "../../Redux/actions/NumBikeation";
// import axios from "axios";
import {
  Button,
  Form,
  DatePicker,
  Radio,
  Select,
  Row,
  Col,
  message,
} from "antd/lib";
import moment from "moment";

export default function Regdateupdate({ setisModalReg }) {
  const dispatch = useDispatch();
  const vehicledetail = useSelector(
    (state) => state.vehicledetail.vechicleDetail
  );
  console.log(vehicledetail);
  const QuickQuotes = useSelector(
    (state) => state.vehicledetail.quickquotes.data
  );
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state.vehicledetail.quickQuotePost
  );
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);
  const [preInsurer, setpreInsurer] = useState([]);
  useEffect(() => {
    dispatch(Previousinsurer()).then((res) => {
      console.log(res);
      setpreInsurer(res);
    });
  }, []);
  const onFinish = (data) => {
    console.log("product data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuotePost,
      registrationDate: moment(data.registrationDate).format("YYYY-MM-DD"),
      policyHolderType: data.vechicleOwned,
      previousInsurerCode: data.customertype,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInstance
      .post(
        `v2/bike_insurances/${auth.bike_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes_Bike(updatedData));
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setLoading(false);
          setisModalReg(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} requiredMark={false} layout="vertical">
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="registrationDate"
              label="Registration Year"
              rules={[
                {
                  required: true,
                  message: "Please select Year",
                },
              ]}
              initialValue={moment(QuotePost.registrationDate)}
            >
              <DatePicker
                style={{ width: "100%" }}
                // disabledDate={disabledDate}
                // onChange={handleDateChange}
                format="YYYY-MM-DD"
                placeholder="Select Registration Year"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="vechicleOwned"
              label="Owner Type"
              rules={[
                {
                  required: true,
                  message: "Please select",
                },
              ]}
              initialValue={QuotePost?.policyHolderType}
            >
              <Radio.Group
                className="py-3 px-3 bg-white ant-radio-layout"
                style={{
                  width: "100%",
                }}
              >
                <Radio value="INDIVIDUAL">Individual</Radio>
                <Radio value="ORGANISATION">Organisation</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              label="previous insurer"
              name="customertype"
              rules={[
                {
                  required: true,
                  message: "Please select previous insurer",
                },
              ]}
              initialValue={QuotePost?.previousInsurerCode}
            >
              <Select
                defaultValue="Select your option"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // onChange={handleChange}
                options={preInsurer?.map((p) => ({
                  key: p.id,
                  value: p.code,
                  label: p.name,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            className="update-qut-button"
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
